import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { DevicesPage } from "@/features/zdalny-dostep/devices-page";
import { ensureElementVisible } from "@/lib/route-guards";

// Widok „Poświadczenia” i jego filtry są w URL-u (F5 i link wracają do tego
// samego widoku); kafelki/tabela urządzeń pamiętają wybór w localStorage.
// `.catch(undefined)`: zły parametr (stary link, ręczna edycja) = brak, a nie
// ZodError wywracający całą stronę Urządzenia (FARMASTER-FRONTEND-33/34).
const searchSchema = z.object({
	widok: z.enum(["poswiadczenia"]).optional().catch(undefined),
	szybki: z.enum(["uwaga", "brak"]).optional().catch(undefined),
	sortBy: z.string().optional().catch(undefined),
	sortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
	// Filtry nagłówkowe DataTable — generyczny JSON [{id, value}].
	columnFilters: z.string().optional().catch(undefined),
});

export type UrzadzeniaSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/konfiguracja/urzadzenia")({
	component: DevicesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.konfiguracja.urzadzenia",
			location.pathname,
		);
	},
	validateSearch: (search: Record<string, unknown>): UrzadzeniaSearch => searchSchema.parse(search),
});
